// extracted by mini-css-extract-plugin
export default {"menu":"Profile_menu__x64ZS","section":"Profile_section__4uRK0","sectionTitle":"Profile_sectionTitle__8jEoN","menuItem":"Profile_menuItem__foyzx","chevron":"Profile_chevron__zxeVV"};